
















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import SignupService from '@/api/SingupService';
import CoinSetupService from '@/api/CoinSetupService';
import InternationalizationService from '@/api/InternationalizationService';

import TextField from '@/components/atoms/TextField/TextField.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ProviderButton from '@/components/molecules/ProviderButton/ProviderButton.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';

import segmentIo from '@/utils/segment.io';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';

@Component({
  components: {
    FilledButton,
    TextField,
    ProviderButton,
    Input,
    ValidationProvider,
    ValidationObserver
  }
})
export default class YourAccountEmail extends Vue {
  @Prop() backUrl!: string;
  @Prop() nextUrl!: string;
  @Prop() redirectUrl!: string;
  @Prop({ default: 'BFR' }) analyticsPrefix!: string;

  signUpService = new SignupService();
  coinSetupService = new CoinSetupService();
  internationalizationService = new InternationalizationService();

  loading = false;

  form = {
    email:
      this.$store.getters['businessOnboarding/getAccountFormData'].email || ''
  };

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  handleGoogleSignUp() {
    segmentIo.track(
      `${this.analyticsPrefix} Sign Up | Clicked Google Signup Button`
    );
    this.signUpService.signupWithProvider('google', {
      referrerURL: window.location.pathname,
      redirect: this.redirectUrl
    });
  }

  handleBack() {
    this.$router.replace(this.backUrl);
  }

  mounted() {
    setFocusOnFirstInput();
    this.$store.dispatch('businessOnboarding/SET_CREATED_ACCOUNT', false);
  }

  async handleSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (!formIsValid) {
      setFocusOnFirstInput('input[aria-invalid="true"]');

      return;
    }

    try {
      this.loading = true;
      const { data } = await this.signUpService.verifyIfEmailExists(
        this.form.email
      );

      if (data.found) {
        formRef.setErrors({
          email: ['Email is already registered.']
        });
        return;
      }

      this.signUpService.storeLead(this.form.email);
    } finally {
      this.loading = false;
    }
    this.$store.dispatch('businessOnboarding/SET_ACCOUNT_FORM', {
      ...this.$store.getters['businessOnboarding/getAccountFormData'],
      email: this.form.email
    });

    segmentIo.track(`${this.analyticsPrefix} Sign Up | Saved Merchant Lead`);

    this.$router.push(this.nextUrl);
  }
}
